interface ContactItem {
  label: string;
  value: string;
  icon: string;
  href?: string;
}

const CONTACT_ITEMS: ContactItem[] = [
  {
    label: "Address",
    value: "106 Makedonia str.",
    icon: "ri-map-pin-2-line",
  },
  {
    label: "City",
    value: "Samokov",
    icon: "ri-building-line",
  },
  {
    label: "Zip",
    value: "2000",
    icon: "ri-barcode-line",
  },
  {
    label: "Country",
    value: "Bulgaria",
    icon: "ri-global-line",
  },
  {
    label: "Email",
    value: "info@zarevood.com",
    icon: "ri-mail-line",
    href: "mailto:info@zarevood.com",
  },
  {
    label: "Phone",
    value: "+1 8146878739",
    icon: "ri-phone-line",
    href: "tel:+18146878739",
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-32 bg-gray-900">
      <div className="max-w-screen-xl mx-auto px-8">
        <div className="grid md:grid-cols-2 gap-16 items-start">
          {/* Left: headline */}
          <div>
            <div className="inline-flex mb-6">
              <span className="text-xs uppercase tracking-widest font-semibold text-teal-400 bg-teal-400/10 px-4 py-1.5 rounded-full">
                Get In Touch
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
              Let&apos;s Start a<br /> Conversation
            </h2>
            <p className="text-gray-400 text-lg leading-relaxed max-w-sm">
              We&apos;re always happy to hear from users, partners, or anyone
              interested in our iOS applications. Reach out through any of the
              contact details below.
            </p>

            {/* Decorative element */}
            <div className="mt-12 flex items-center gap-4">
              <div className="w-12 h-0.5 bg-teal-500" />
              <span className="text-teal-400 text-sm font-medium tracking-wide">
                ZAREV OOD
              </span>
            </div>
          </div>

          {/* Right: contact info */}
          <div className="bg-white rounded-3xl p-10">
            <h3 className="text-lg font-bold text-gray-900 mb-8">
              Contact Information
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {CONTACT_ITEMS.map((item) => (
                <div key={item.label} className="flex flex-col gap-1.5">
                  <div className="flex items-center gap-2">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={`${item.icon} text-teal-500 text-base`} />
                    </div>
                    <span className="text-xs font-semibold uppercase tracking-widest text-gray-400">
                      {item.label}
                    </span>
                  </div>
                  {item.href ? (
                    <a
                      href={item.href}
                      className="text-gray-800 font-medium text-sm pl-7 hover:text-teal-600 transition-colors cursor-pointer"
                    >
                      {item.value}
                    </a>
                  ) : (
                    <span className="text-gray-800 font-medium text-sm pl-7">
                      {item.value}
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
